import ClassNameExtendableHoC from 'components/HoC/ClassNameExtendableHoC';

const ParSmall = ClassNameExtendableHoC('p', 'ds-text-body _small_');

export {
  ParSmall,
};
